<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card height="80vh" class="edit-mission-main-card">
          <v-row no-gutters>
            <v-col cols="12" class="modal-header py-5">
              <v-row no-gutters>
                <v-col cols="1">
                  <span class="phone-code">
                    <span class="ml-1 mr-2">کد:</span>
                    {{ phoneCode }}
                  </span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" class="mt-3">
                  <v-row>
                    <span :class="editInfoTabClass" @click="changeTab('mission')">
                      اطلاعات ماموریت
                    </span>
                    <v-spacer></v-spacer>
                    <span :class="timeTabClass" @click="changeTab('time')">زمان ها و وضعیت</span>
                    <v-spacer></v-spacer>
                    <span :class="doctorInsideTabClass" @click="changeTab('doctor')">
                      دستورات پزشکی
                    </span>
                    <v-spacer></v-spacer>
                    <span :class="moreTabClass" @click="changeTab('moreInfo')">سایر اطلاعات</span>
                    <v-spacer></v-spacer>
                    <span :class="noteTabClass" @click="changeTab('note')">توضیحات</span>
                    <v-spacer></v-spacer>
                    <span :class="addressTabClass" @click="changeTab('address')">سابقه آدرس</span>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="1" class="text-left mt-n2 ml-2">
                  <v-icon color="darkColor" @click="closeMissionDetailModal()">mdi-close</v-icon>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-card-text class="mt-3">
            <v-row no-gutters>
              <v-col cols="12" v-if="followUpDashboardDetailTab == 'mission'">
                <v-row>
                  <span class="mr-3">اطلاعات اصلی</span>
                  <v-divider class="mr-2 mt-3"></v-divider>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-card class="card-info-send-mission" elevation="0" height="5vh">
                      <v-card-text>
                        <v-row>
                          <span class="mt-1 send-mission-info-title-content">آدرس:</span>
                          <span class="mr-2 mt-1 send-mission-info-text-content">
                            {{ missionAddress }}
                          </span>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card class="card-info-send-mission" elevation="0" height="5vh">
                      <v-card-text>
                        <v-row>
                          <span class="mt-1 send-mission-info-title-content">شکایت اصلی:</span>
                          <span class="mr-2 mt-1 send-mission-info-text-content">
                            {{ missionCheifCompliant }}
                          </span>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="9">
                    <v-card class="card-info-send-mission" elevation="0" height="5vh">
                      <v-card-text>
                        <v-row>
                          <span class="mt-1 send-mission-info-title-content">توضیح شکایت:</span>
                          <span class="mr-2 mt-1 send-mission-info-text-content">
                            {{ missionCheifCompliantNote }}
                          </span>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row class="mt-10">
                  <v-col cols="4">
                    <v-row>
                      <span class="mr-3">شماره های تلفن</span>
                      <v-divider class="mt-2 mr-3 ml-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-card elevation="0" class="edit-modal-card-detail" height="30vh">
                          <v-card-text>
                            <v-row>
                              <v-col cols="6" v-for="(item, index) in listOfMissionCallerIds" :key="index">
                                <span class="phone-numbers-items mt-2 ml-2">
                                  {{ item }}
                                  <v-icon @click="callToPatient(item)" color="white"
                                    class="phone-numbers-items-icon mr-3">
                                    mdi-phone mdi-18px
                                  </v-icon>
                                </span>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="4">
                    <v-row>
                      <span class="mr-3">برچسب ها</span>
                      <v-divider class="mt-2 mr-3 ml-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-card elevation="0" class="edit-modal-card-detail" height="30vh">
                          <v-card-text>
                            <v-row>
                              <v-col cols="10" class="mt-n1">
                                <v-autocomplete :items="allTagsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                                  outlined clearable clear-icon="mdi-close-circle-outline" item-text="title"
                                  item-value="id" return-object label="برچسب ها" autocomplete="off"
                                  v-model="selectedMissionTag" prepend-inner-icon="mdi-tag mdi-18px"
                                  style="font-size: 11px !important"></v-autocomplete>
                              </v-col>
                              <v-col cols="2" class="mr-n2">
                                <v-btn color="darkColor" small class="py-3" block elevation="0"
                                  @click="addMissionTag()">
                                  <v-icon color="white">mdi-plus mdi-18px</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-chip close close-icon="mdi-close" class="mr-2"
                              @click:close="removeMissionTag(item.missionTagId)" small v-for="item in missionTagList"
                              :key="item.id">
                              {{ item.title }}
                            </v-chip>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="4">
                    <v-row>
                      <span class="mr-3">مناطق فاقد کد</span>
                      <v-divider class="mt-2 mr-3 ml-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-card elevation="0" class="edit-modal-card-detail" height="30vh">
                          <v-card-text>
                            <v-chip class="mr-2 mt-2" small v-for="item in listOfMissionLakeCodeStation" :key="item.id">
                              {{ item.titleCode }}
                            </v-chip>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="followUpDashboardDetailTab == 'time'">
                <v-row>
                  <v-col cols="12" class="mb-9">
                    <v-row>
                      <span>زمان ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="mt-n3">
                    <v-row>
                      <v-col class="" v-for="item in missionTimes" :key="item.id" :cols="item.size">
                        <user-detail-component has-icon v-if="item.title" :title="item.title" :size="item.size"
                          :text="item.text" :icon="item.icon" :per="item.per" :perKey="item.perKey"
                          :secondText="item.secondText"></user-detail-component>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="mt-4">
                    <v-row>
                      <span class="mr-3">وضعیت ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="">
                    <edit-dialog-information-component v-if="followUpDashboardDetailTab == 'time'"
                      :tableHeader="stateDataTableHeader" :tableItems="stateDataTableItems"
                      :height="'30vh'"></edit-dialog-information-component>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="followUpDashboardDetailTab == 'note'">
                <v-row>
                  <span>توضیحات</span>
                  <v-divider class="mt-2 mr-3"></v-divider>
                </v-row>
                <v-row>
                  <v-col cols="12" class="note-component-space mt-n4">
                    <v-row>
                      <v-col cols="12" v-for="item in noteList" :key="item.id" class="mb-5">
                        <dispatch-note-component :user="item.user" :date="item.date"
                          :note="item.note"></dispatch-note-component>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-card elevation="0" height="17vh" class="note-box">
                      <v-row>
                        <v-col cols="2" class="not-box-title">
                          <span>افزودن توضیحات</span>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="12" class="note-box-input">
                          <v-row>
                            <v-spacer></v-spacer>
                            <v-col cols="11">
                              <v-textarea outlined prepend-inner-icon="mdi-text mdi-18px" rows="2"
                                @keydown="noteHandler" clearable clear-icon="mdi-close-circle-outline"
                                placeholder="توضیحات" v-model="noteText"></v-textarea>
                            </v-col>
                            <v-spacer></v-spacer>
                          </v-row>
                          <v-row>
                            <v-col cols="12" class="mt-n10">
                              <v-row>
                                <v-spacer></v-spacer>
                                <v-btn color="lightColor" @click="addNote()" class="ml-4 normal-letter-spacing" text>
                                  <v-icon color="lightColor">mdi-check mdi-18px</v-icon>
                                  ثبت توضیحات
                                </v-btn>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="followUpDashboardDetailTab == 'address'">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="6">
                        <v-row>
                          <span>نقشه</span>
                          <v-divider class="mt-3 mr-2 ml-2"></v-divider>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <div id="map">
                              <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 60vh !important" :zoom="zoom"
                                :center="center" :options="mapOptions" @update:center="centerUpdate"
                                @update:zoom="zoomUpdate" @ready="mapInvalidate()">
                                <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
                                <l-polyline :lat-lngs="polyline.latlngs" :color="polyline.color"></l-polyline>
                                <l-control position="bottomleft">
                                  <v-btn small rounded dark color="darkColor" class="no-letter-space"
                                    @click="showLine()">
                                    مشاهده مسیر
                                  </v-btn>
                                </l-control>
                                <!--<v-geosearch :options="geosearchOptions"></v-geosearch>-->
                                <!-- Marker -->
                                <l-marker v-if="
                                  patiantPosition && patiantPosition.lat && patiantPosition.lng
                                " visible :icon="icon" :lat-lng.sync="patiantPosition"></l-marker>
                                <l-marker ref="marker" v-if="phoneOnlineLocation" :lat-lng="[
                                  phoneOnlineLocation.latitude,
                                  phoneOnlineLocation.longitude,
                                ]" :icon="getMovingIcon(phoneOnlineLocation)">
                                  <l-popup ref="popup">
                                    {{ phoneOnlineLocation?.phone?.code }}
                                  </l-popup>
                                </l-marker>
                              </l-map>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row>
                          <span>سابقه آدرس</span>
                          <v-divider class="mt-3 mr-2"></v-divider>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <edit-dialog-information-component v-if="followUpDashboardDetailTab == 'address'"
                              :tableHeader="addressDataTableHeader" :tableItems="addressDataTableItems"
                              :height="'60vh'"></edit-dialog-information-component>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="followUpDashboardDetailTab == 'doctor'">
                <v-row>
                  <v-col class="doctor-part" cols="12" v-for="item in allDoctorOrders" :key="item.id">
                    <v-row class="mt-1">
                      <span class="mr-4">{{ item.patient }}</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorInfoDataTableHeader"
                          :tableItems="item.doctorInfoDataTableItems"
                          :height="'10vh'"></edit-dialog-information-component>
                      </v-col>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorDrugDataTableHeader"
                          :tableItems="item.doctorDrugDataTableItems"
                          :height="'30vh'"></edit-dialog-information-component>
                      </v-col>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorOrderDataTableHeader"
                          :tableItems="item.doctorOrderDataTableItems"
                          :height="'30vh'"></edit-dialog-information-component>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="followUpDashboardDetailTab == 'moreInfo'">
                <v-row>
                  <v-col class="doctor-part" cols="12">
                    <v-row class="mt-2">
                      <span class="mr-4">اطلاعات پذیرش</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="mt-1">
                        <edit-dialog-information-component :tableHeader="admissionDataTableHeader"
                          :tableItems="admissionDataTableItems" :height="'25vh'"></edit-dialog-information-component>
                      </v-col>
                    </v-row>
                    <v-row class="mt-4">
                      <span class="mr-4">درخواست های سایر ارگان ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="mt-1">
                        <edit-dialog-information-component :tableHeader="otherOrganDataTableHeader"
                          :tableItems="otherOrganDataTableItems" :height="'25vh'"></edit-dialog-information-component>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import { latLng } from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LControl, LPolyline } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

import AlertComponent from '@/components/AlertComponent.vue';
import UserDetailComponent from '../UserDetailComponentNew.vue';
import EditDialogInformationComponent from '../115/EditDialogInformationComponent.vue';
import DispatchNoteComponent from '@/components/800/DispatchNoteComponent.vue';

import confirmDialog from '@/components/ConfirmDialog.vue';

import snackBar from '@/Mixins/snackBar.js';
import SharedMap from '@/Mixins/map';
import SharedMixin from '@/Mixins/Shared';
import TagMixin from '@/Mixins/BaseInformation/TagMixin';
import CityMixin from '@/Mixins/BaseInformation/CityMixin';
import MissionPhonesMixin from '@/Mixins/Mission/MissionPhonesMixin';
import missionStateMixin from '@/Mixins/Mission/MissionStateMixin';
import missionNoteMixin from '@/Mixins/Mission/MissionNoteMixin';
import HospitalMixin from '@/Mixins/BaseInformation/HospitalMixin';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin';
import DispatchCodeMixin from '@/Mixins/BaseInformation/DispatchCodeMixin';
import StationMixin from '@/Mixins/BaseInformation/StationMixin';
import MissionAddressLogMixin from '@/Mixins/Mission/MissionAddressLogMixin';
import MissionMixin from '@/Mixins/Mission/MissionMixin';
import PhoneOnlineLocationMixin from '@/Mixins/BaseInformation/PhoneOnlineLocationMixin';
import PatientDoctorDetailMixin from '@/Mixins/Doctor/PatientDoctorDetailMixin';
import CallMixin from '@/Mixins/Call/CallMixin';

import FollowUpDashboardDetailHelper from '@/Helpers/FollowUp/FollowUpDashboardDetailHelper.js';
export default {
  name: 'FollowUpDashboardDetail',
  title: 'جزئیات ماموریت',
  inject: ['load'],
  components: {
    UserDetailComponent,
    EditDialogInformationComponent,
    AlertComponent,
    DispatchNoteComponent,
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LPolyline,
    confirmDialog
  },
  mixins: [
    FollowUpDashboardDetailHelper,
    snackBar,
    SharedMixin,
    TagMixin,
    CityMixin,
    MissionPhonesMixin,
    missionStateMixin,
    missionNoteMixin,
    HospitalMixin,
    ZoneMixin,
    DispatchCodeMixin,
    StationMixin,
    MissionAddressLogMixin,
    MissionMixin,
    PhoneOnlineLocationMixin,
    PatientDoctorDetailMixin,
    CallMixin,
    SharedMap,
  ],
  created() {
    this.$root.$refs.FollowUpDashboardDetail = this;
  },
  mounted() {
    this.mounteLoding();
  },
  props: {
    missionId: {
      type: Number,
      require: true,
      default: null,
    },
    missionPhoneId: {
      type: Number,
      require: true,
      default: null,
    },
    phoneCode: {
      type: String,
      require: true,
    },
    phoneId: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      patiantPosition: {},
      dragging: false,
      icon: this.getIcon,
    };
  },
  methods: {
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      this.getMissionByfollowUpFunction(this.missionPhoneId);
      this.getListOfTagsForOther();
      this.setMapBaseSystemSetting();
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
      }, 100);
      setTimeout(() => {
        this.$refs.marker.mapObject.openPopup();
      }, 300);
    },
    getMovingIcon(data) {
      if (data.isPhoneLocation == true) {
        //is phone
        if (data.hasMission == true) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForPhoneWithMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        } else if (data.hasMission == false) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForPhoneWithOutMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        }
      } else if (data.isPhoneLocation == false) {
        //is gps
        if (data.hasMission == true) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForGPSWithMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        } else if (data.hasMission == false) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForGPSWithOutMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        }
      }
    },
  },
};
</script>
<style scoped>
.card-info-send-mission {
  border-right: 3px solid var(--dark-color) !important;
  border-left: 3px solid var(--dark-color) !important;
  border-top: 2px solid var(--background-color) !important;
  border-bottom: 2px solid var(--background-color) !important;
  border-radius: 10px !important;
}

.send-mission-info-title-content {
  color: #212121 !important;
  font-weight: 500;
  font-size: 14px;
}

.send-mission-info-text-content {
  color: #212121 !important;
  font-weight: 400;
  font-size: 12px;
}

.edit-modal-card-detail {
  border-radius: 12px !important;
  border: 1px solid var(--dark-color) !important;
}

.modal-title-text-menu {
  cursor: pointer;
}

.phone-numbers-items {
  background: var(--background-color) !important;
  border-radius: 5px !important;
  padding-right: 15px !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}

.phone-numbers-items-icon {
  background: var(--dark-color) !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  border-radius: 5px !important;
}

.edit-mission-main-card {
  overflow-y: auto;
}

.note-box {
  border: 1px solid #909090 !important;
  border-radius: 12px !important;
}

.not-box-title {
  position: absolute;
  background: white;
  padding-right: 20px !important;
  margin-top: -1.4vh !important;
  margin-right: 45px !important;
}

.note-box-input {
  margin-top: 2.5vh !important;
}

.note-component-space {
  height: 45vh !important;
  overflow-y: auto !important;
}

.phone-code {
  color: var(--dark-color);
  margin-right: 5px !important;
}

.menu-top-items {
  cursor: pointer !important;
}

.active-tab {
  color: var(--dark-color) !important;
  background: var(--background-color) !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border-radius: 5px !important;
}
</style>
